import React, { useState, useCallback, useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const Carousel = ({ children, className, slideClassName, showPagination = true, loop = true, align = 'start', autoPlay = false, activeSlide, onSlideChange = () => null, }) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop, align }, autoPlay ? [Autoplay()] : []);
    const [scrollSnaps, setScrollSnaps] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const onInit = useCallback((emblaApi) => {
        setScrollSnaps(emblaApi.scrollSnapList());
    }, []);
    const onSelect = useCallback((emblaApi) => {
        const newIndex = emblaApi.selectedScrollSnap();
        setSelectedIndex(newIndex);
        onSlideChange(newIndex);
    }, []);
    const scrollTo = useCallback((index) => emblaApi && emblaApi.scrollTo(index), [emblaApi]);
    useEffect(() => {
        if (!emblaApi) {
            return;
        }
        onInit(emblaApi);
        onSelect(emblaApi);
        emblaApi.on('reInit', onInit);
        emblaApi.on('reInit', onSelect);
        emblaApi.on('select', onSelect);
    }, [emblaApi, onInit, onSelect]);
    useEffect(() => {
        if (activeSlide) {
            scrollTo(activeSlide);
        }
    }, [activeSlide, scrollTo]);
    return (React.createElement("div", { className: [className, 'embla'].join(' '), ref: emblaRef },
        React.createElement("div", { className: "embla-container" }, React.Children.map(children, (child, key) => (React.createElement("div", { key: key, className: [
                slideClassName,
                selectedIndex === key ? 'embla-slide-active' : '',
                'embla-slide',
            ].join(' ') }, child)))),
        showPagination ? (React.createElement("div", { className: "embla-pagination" }, scrollSnaps.map((_, i) => (React.createElement("span", { key: i, className: [
                'embla-pagination-bullet',
                selectedIndex === i ? 'embla-pagination-bullet-active' : '',
            ].join(' '), tabIndex: 0, role: "button", "aria-label": `Go to slide ${i}`, onClick: () => scrollTo(i) }))))) : null));
};

export { Carousel };
//# sourceMappingURL=Carousel.js.map
